<script setup lang="ts">
import type { SideBoxProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SideBoxProps>(), {
  header: '',
  linkTo: null,
})
</script>

<template>
  <div class="c-sidebox">
    <SideHeading
      v-bind:header="header"
      v-bind:link-to="linkTo"
    />
    <div class="c-sidebox_body">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-sidebox {
  padding: 15px 20px;
  border: 1px solid #ebebeb;
}
</style>
